import { useState } from 'react';
import { Loader2, SquareArrowOutUpRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button, buttonVariants } from 'components/ui/button';
import { Checkbox } from 'components/ui/checkbox';
import { getMilestoneTag } from 'lib/utils';
import Loader from 'components/Loader';
import { useGetTnC, usePostOnboardingStep } from 'services/dashboard/hooks';

export default function TermAndCondition() {
  const { t } = useTranslation();

  const [checked, setChecked] = useState<boolean>(false);

  const { data, isFetching } = useGetTnC();
  const { mutate, isPending } = usePostOnboardingStep();

  const onAccept = () => {
    const milestone = getMilestoneTag('tnc');
    mutate({ milestone });
  };

  if (isFetching) return <Loader />;

  return (
    <div className='flex items-center justify-center h-full max-w-lg px-4 py-8 mx-auto'>
      <div className='flex flex-col space-y-8'>
        <p className='leading-tight whitespace-pre-wrap text-balance'>
          {data?.content}
        </p>

        <div className='flex justify-center max-w-md gap-8 mx-auto'>
          <a
            href={process.env.REACT_APP_MEDSI_TOC}
            target='_blank'
            rel='noopener noreferrer'
            className={buttonVariants({
              variant: 'link',
              className: 'cursor-pointer',
            })}
          >
            {t('tnc')}
            <SquareArrowOutUpRight className='inline w-4 h-4 ml-2' />
          </a>
          <a
            href={process.env.REACT_APP_MEDSI_PRIVACY}
            target='_blank'
            rel='noopener noreferrer'
            className={buttonVariants({
              variant: 'link',
              className: 'cursor-pointer',
            })}
          >
            {t('pp')}
            <SquareArrowOutUpRight className='inline w-4 h-4 ml-2' />
          </a>
        </div>

        <div className='flex flex-col items-center justify-center gap-8 mx-4 sm:justify-between sm:flex-row sm:mx-0'>
          <div className='flex items-center gap-4'>
            <Checkbox
              checked={checked}
              onCheckedChange={(checked: boolean) => setChecked(checked)}
              className='size-5'
              id='agree-tnc-pp'
            />
            <label className='leading-tight' htmlFor='agree-tnc-pp'>
              {t('agree_tnc_pp')}
            </label>
          </div>

          <Button disabled={!checked || isPending} onClick={onAccept}>
            {isPending && (
              <Loader2
                role='progressbar'
                className='w-4 h-4 mr-2 text-white animate-spin'
              />
            )}
            {t('accept')}
          </Button>
        </div>
      </div>
    </div>
  );
}
